import React from 'react'
import { Drawer } from 'antd'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { FaBus, FaLink, FaEye, FaBuilding, FaRoute } from 'react-icons/fa'
import { allPaths, translations } from '../../utils/constants'

// Right-side drawer opened from a line's badge on the dashboard and the
// Route History page: the vehicles behind that line today — the ones
// assigned to it and the ones that ran it — with their organisation, trips
// and km, and a shortcut to each vehicle's details.
const LineVehiclesDrawer = ({ line, open, onClose, language }) => {
  const history = useHistory()
  const t = translations[language] || {}
  const vehicles = line?.vehicles || []
  const attached = vehicles.filter((v) => v.attached).length
  const orgs = line?.organizations || []

  return (
    <Drawer
      placement='right'
      width={460}
      visible={open}
      onClose={onClose}
      className='gl-drawer'
      title={
        line ? (
          <div className='lv-title'>
            <span className='dash-line-badge'>{line.line}</span>
            <span className='lv-title-text'>{t.lineVehicles}</span>
          </div>
        ) : null
      }
    >
      {line && (
        <>
          <div className='gl-summary'>
            <span className='gl-chip'>
              <strong>{vehicles.length}</strong> {t.vehiclesShort}
            </span>
            <span className='gl-chip'>
              <strong>{attached}</strong> {t.attachedToLine}
            </span>
            <span className='gl-chip'>
              <strong>{line.trips || 0}</strong> {t.tripsToday}
            </span>
            {line.km_traveled > 0 && (
              <span className='gl-chip'>
                <strong>{line.km_traveled}</strong> km
              </span>
            )}
          </div>

          {orgs.length > 0 && (
            <div className='lv-orgs'>
              <FaBuilding className='lv-orgs-icon' />
              <span>{orgs.join(' · ')}</span>
            </div>
          )}

          {vehicles.length === 0 ? (
            <div className='gl-empty'>{t.noVehiclesOnLine}</div>
          ) : (
            <div className='lv-list'>
              {vehicles.map((v) => (
                <div className='lv-row' key={v.id}>
                  <div className='lv-row-icon'>
                    <FaBus />
                  </div>
                  <div className='lv-row-body'>
                    <div className='lv-row-head'>
                      <span className='lv-row-name'>{v.vehicle_name || v.license_plate || v.id}</span>
                      {v.attached ? (
                        <span className='lv-tag lv-tag-attached'>
                          <FaLink size={10} /> {t.attachedToLine}
                        </span>
                      ) : (
                        <span className='lv-tag'>{t.ranTodayOnly}</span>
                      )}
                    </div>
                    <div className='lv-row-meta'>
                      {v.license_plate && <span className='vl-plate'>{v.license_plate}</span>}
                      {v.organization_name && (
                        <span className='lv-row-org'>
                          <FaBuilding size={10} /> {v.organization_name}
                        </span>
                      )}
                    </div>
                    <div className='lv-row-stats'>
                      <span>
                        <FaRoute size={10} /> <strong>{v.trips}</strong> {t.tripsToday}
                      </span>
                      {v.km_traveled > 0 && <span><strong>{v.km_traveled}</strong> km</span>}
                      {v.last_end_time && moment(v.last_end_time).isValid() && (
                        <span>
                          {t.lastRunAt} <strong>{moment(v.last_end_time).format('HH:mm')}</strong>
                        </span>
                      )}
                    </div>
                  </div>
                  <button
                    type='button'
                    className='vl-action-btn'
                    title={t.vehicleDetails}
                    onClick={() => history.push({ pathname: `${allPaths?.VEHICLESDETAILS}/${v.id}`, state: v })}
                  >
                    <FaEye size={14} />
                  </button>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </Drawer>
  )
}

export default LineVehiclesDrawer
